import styled from 'styled-components';

const TotalsSeparator = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;
export default TotalsSeparator;
